import { gql } from "@apollo/client";

const FETCH_INVOICE_SALES_PERSON_TYPES = gql`
  query FetchInvoiceSalesPersonTypes {
    invoiceSalesPersonTypes {
      id
      name
    }
  }
`;

export { FETCH_INVOICE_SALES_PERSON_TYPES };
